import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {SellerServicesFactory} from '../../seller/Services/factory.js'
import {GenericUserError} from '../../user/Errors/GenericUserError.js'
import UserServicesFactory from '../../user/Services/factory.js'
import {GetUserAdsError} from '../Errors/GetUserAdsError.js'
import {GetUserAdsService} from '../Services/GetUserAdsService.js'

class GetUserAdsUseCase extends UseCase {
  #config
  #getCurrentUserService
  #getInstantOfferByAdService
  #getUserAdsService

  static create({config}) {
    return new GetUserAdsUseCase({config})
  }

  constructor({config}) {
    super()
    this.#config = config
    this.#getCurrentUserService = UserServicesFactory.getCurrentUserService({config: this.#config})
    this.#getInstantOfferByAdService = SellerServicesFactory.getInstantOfferByAdSellerService({config: this.#config})
    this.#getUserAdsService = GetUserAdsService.create({config: this.#config})
  }

  @tracer({metric: 'GetUserAdsUseCase#execute'})
  @AsyncInlineError()
  async execute({withInstantOfferAppraisal = false} = {}) {
    const userEntity = await this.#getCurrentUserService.execute()
    if (!userEntity)
      return Promise.reject(GenericUserError.create({message: '[GetUserAdsUseCase#execute] User must be logged'}))

    const [getUserAdsError, userAdsListVO] = await this.#getUserAdsService.execute({
      userEntity
    })

    if (getUserAdsError) return Promise.reject(GetUserAdsError.create({message: getUserAdsError.toJSON()}))

    if (!withInstantOfferAppraisal) return userAdsListVO.toJSON()

    const userAdsList = userAdsListVO.toJSON()

    for (const userAd of userAdsList.ads) {
      if (!userAd.isAppraisable) continue
      const [, instantOfferEntity] = await this.#getInstantOfferByAdService.execute({
        adId: userAd.adId,
        simulate: true
      })
      userAd.instantOfferAppraisal = instantOfferEntity?.toJSON().appraisal?.priceRecommended?.value
    }

    return userAdsList
  }
}

export const factory = GetUserAdsUseCase.create
